import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useActiveSeason } from '@/lib/season/SeasonContext';

function formatRu(iso: string): string {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

/**
 * Sticky жёлтая полоса под header — edit_unlock=true для неактивного сезона.
 */
export function SeasonEditUnlockBanner() {
  const { season, setEditUnlock } = useActiveSeason();
  if (!season || season.isCurrent || !season.editUnlock) return null;

  return (
    <Alert
      variant="warning"
      className="rounded-none border-x-0 border-t-0 flex items-center justify-between gap-4"
    >
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 mt-0.5" />
        <AlertDescription>
          Вы редактируете <strong>сезон {season.year}</strong> — даты новых
          записей по умолчанию ={' '}
          <strong>{formatRu(season.asOfDate)}</strong>.
        </AlertDescription>
      </div>
      <Button size="sm" variant="outline" onClick={() => setEditUnlock(false)}>
        Выйти из режима
      </Button>
    </Alert>
  );
}

export default SeasonEditUnlockBanner;
